/**
 * App base path from CRA PUBLIC_URL (e.g. /booking-app-test or / for ROOT prod).
 * Same as BrowserRouter basename.
 */
export function getAppBasePath() {
    const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    return publicUrl;
}

/** Full browser path for a react-router pathname (base path + route). */
export function toAppPath(routePathname) {
    return `${getAppBasePath()}${routePathname}`;
}
